// test618
(618 && 0);
